// Autogenerated by Hanako
import { Analytics } from '../../views/ts/components/Analytics';
import { ExternalContent } from '../../views/ts/components/ExternalContent';
import { Expendable } from '../../views/ts/components/Expendable';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Carousel } from '../../views/twig/components/Carousel';
import { Collapse } from '../../views/twig/components/Collapse';
import { CookiesConsent } from '../../views/twig/components/CookiesConsent';
import { Menu } from '../../views/twig/components/Menu';
import { Production } from '../../views/twig/pages/singles/production';
import { FrontPage } from '../../views/twig/pages/root/front-page';
import { FrontPage2 } from '../../views/twig/pages/page-templates/front-page';
import { Fediverse } from '../twig/components/Fediverse';
import { Newsletter } from '../twig/modules/newsletter';
(new Analytics()).init();
(new ExternalContent()).init();
(new Expendable()).init();
(new LazyLoader()).init();
(new Carousel()).init();
(new Collapse()).init();
(new Menu()).init();
(new Production()).init();
(new FrontPage()).init();
(new FrontPage2()).init();
(new Fediverse()).init();
(new Newsletter()).init();
(new CookiesConsent()).init();
